import { Actions } from "@/components/framework/locationswitcher/locationReducer";
import { ActionDispatch } from "react";
import styles from "./TheaterButton.module.css";
import { BygdekinoenLocation } from "@/sanity/sanity.types";

//#region [Props]
type TheaterButtonProps = {
    theater: BygdekinoenLocation;
    dispatch: ActionDispatch<[action: Actions]>;
};
//#endregion

//#region [Component]
export default function TheaterButton({ dispatch, theater }: TheaterButtonProps) {
    return <button className={styles.TheaterButton} onClick={() => dispatch({ type: "addLocation", value: theater })}>{theater.name}, {theater.location ?? theater.poststed}</button>;
}
//#endregion

//#region [Styles]

//#endregion